import React, { useState } from 'react'
import './styles.scss'
import { useSelector } from 'react-redux'
import { MnemonicsBadge } from 'components/mnemonics'
import { lang } from 'utils/helpers'
import { MultiAvatar, StatusPoint } from 'components/common'
import { getNamesCardInChat } from 'utils/usersHelpers'
import { typeInchat } from 'constants/channels'
import StateChannelCard from './StateChannelCard'
import MenuChannel from './MenuChannel'
import ModalChannelView from '../../Containers/ChannelsContainer/ModalChannelView'
import { validateOneDeactivatedUser } from 'components/InChatView/utils'

const TYPECARD = ['modal']

const UserCard = ({
  conversation,
  onClick,
  typeCard='pool',
  color='#FFFFFF',
  onClickExit,
  handleClickJoin,
  conversationAction,
  withModalInfo
}) => {
  const { totalUnreadMessages, type, name, usersInfo } = conversation
  const idOperator = useSelector(state => state.user.id)
  const [hideMenu, setHideMenu] = useState(true)
  const inModal = TYPECARD.includes(typeCard)
  const typeChannel = typeInchat.includes(type)
  const [isOpenModalChannelView, setIsOpenModalChannelView] = useState(false)

  const getTextSubtitle = (users = []) => {
    let text = ''
    let userLength = users.length
    if(userLength > 1 && !typeChannel){
      text = `${userLength} ${lang('dashboard_people')}`
    }else if (userLength === 1){
      text = ''
    }
    return inModal ? `${usersInfo.length} ${usersInfo.length > 1 ? lang('dashboard_members') : lang('dashboard_member')}`.toLowerCase() : text
  }

  const handleClick = (e) => {
    if( typeof e.target.className === 'string' && e.target.className){
      if((e.target.className.trim().startsWith('inchat-user-card') || e.target.className.trim().startsWith('multi-avatar-container')) && !inModal) {
        onClick(conversation)
      }
    }
  }

  const newUsersInfo = usersInfo ? usersInfo.filter((user) => user._id !== idOperator) : []

  const handleViewOptions = (value) => {
    if(typeChannel && !inModal) {
      setHideMenu(value)
    }
  }

  const openModalChannelView = () => {
    setIsOpenModalChannelView(state => !state)
  }

  const names = getNamesCardInChat(newUsersInfo, type, name)

  return (
    <div
      className={`
      inchat-user-card__container
      ${typeChannel ? 'inchat-user-card__container--channel' : ''}
      ${!typeChannel && validateOneDeactivatedUser(newUsersInfo) ? 'inchat-user-card__container--opacity': ''}
      `}
      onClick={(e) => handleClick(e)}
      onMouseOver={() => handleViewOptions(false)}
      onMouseLeave={() => handleViewOptions(true)}
      style={{
        backgroundColor: color,
        boxShadow: color === 'transparent'? '0 0 0 0' : '',
        cursor: inModal ? 'default' : 'pointer',
      }}
      title={names}
    >
      <div className='inchat-user-card__container--avatar-text' >
        {type === 'direct' && !validateOneDeactivatedUser(newUsersInfo)
          ? <StatusPoint
            status={newUsersInfo[0].status.toUpperCase()}
            className='inchat-user-card__container--avatar-text--position'
          />
          : null }
        <MultiAvatar
          users={newUsersInfo}
          type={type}
          conversationPrivate={conversation.private}
          name={name} />
        <div
          className={`
          inchat-user-card-text
          ${inModal ? 'inchat-user-card-text--modalCard':''}
          `}
        >
          <p className='inchat-user-card-text__text inchat-user-card-text__text--title' >{names}</p>
          { typeChannel && conversation.usersInfo.length > 0 && getTextSubtitle(newUsersInfo) !== '' &&
            <p className='inchat-user-card-text__text inchat-user-card-text__text--subtitle'>{getTextSubtitle(newUsersInfo)}</p>
          }
        </div>
      </div>
      <div className='inchat-user-card__container--mnemonic'>
        {typeChannel
          ? !inModal
            ? <MenuChannel
              conversation={conversation}
              hideMenu={hideMenu}
              conversationAction={conversationAction}
              openModalChannelView={openModalChannelView}
            />
            : <StateChannelCard
              conversation={conversation}
              operator={idOperator}
              onClickExit={onClickExit}
              handleClickJoin={handleClickJoin}
            />
          : <MnemonicsBadge location='userCard' value={totalUnreadMessages}/>
        }
      </div>
      {withModalInfo && (
        <ModalChannelView
          isOpenModal={isOpenModalChannelView}
          toggleOpen={openModalChannelView}
          conversation={conversation}
          conversationAction={conversationAction}
        />
      )}
    </div>
  )
}

export default UserCard